// Auf Android 2.3 etc klappt das leider nicht mit reinem Css:
// [type="checkbox"]:not (:checked ) ~ label.checkbox:after, label.checkbox.checked:after
// Der Checkbox wechsel klappt beim css erst, wenn man die orientation ändert.
// Daher hier per Jquery gefixt.
import $ from 'jquery'

$("select.icon").change(function () {
    $(this).attr("data-style", this.value);
});